(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["countdown-w"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('countdown-w')) {
    customElements.define(
      'countdown-w',
      class CountdownW extends HTMLElement {
        connectedCallback() {
          this.end = Date.parse(this.dataset.end);
          if (Number.isNaN(this.end)) return;
          this.nums = {};
          this.querySelectorAll('[data-unit]').forEach((el) => (this.nums[el.dataset.unit] = el));
          this.tick();
          this.timer = setInterval(() => this.tick(), 1000);
        }
        disconnectedCallback() {
          clearInterval(this.timer);
        }
        tick() {
          const diff = this.end - Date.now();
          if (diff <= 0) {
            clearInterval(this.timer);
            this.classList.add('cd-w--ended');
            const expired = this.querySelector('.cd-w__expired');
            if (expired) expired.hidden = false;
            return;
          }
          const s = Math.floor(diff / 1000);
          const parts = { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
          Object.keys(parts).forEach((k) => {
            if (this.nums[k]) this.nums[k].textContent = String(parts[k]).padStart(2, '0');
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["petals-w"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('petals-w')) {
    customElements.define(
      'petals-w',
      class PetalsW extends HTMLElement {
        connectedCallback() {
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          if (this.classList.contains('petals-w--hide-mobile') && window.innerWidth < 750) return;
          this.canvas = this.querySelector('canvas');
          this.ctx = this.canvas.getContext('2d');
          this.colors = (this.dataset.colors || '#E6AF2E').split(',').filter(Boolean);
          this.shapes = (this.dataset.shapes || 'petal').split(',').map((x) => x.trim()).filter(Boolean);
          this.font = getComputedStyle(this).fontFamily || 'sans-serif';
          this.speed = Number(this.dataset.speed) || 4;
          this.size = Number(this.dataset.size) || 16;
          this.alpha = (Number(this.dataset.opacity) || 90) / 100;
          this.visible = true;
          this.running = false;
          this.tick = this.tick.bind(this);
          this.resize = this.resize.bind(this);

          this.resize();
          window.addEventListener('resize', this.resize);

          this.observer = new IntersectionObserver((entries) => {
            this.visible = entries[0].isIntersecting;
            this.toggle();
          });
          this.observer.observe(this.classList.contains('petals-w--fixed') ? document.body : this);

          this.onVisibility = () => this.toggle();
          document.addEventListener('visibilitychange', this.onVisibility);
          this.toggle();
        }

        disconnectedCallback() {
          this.running = false;
          cancelAnimationFrame(this.frame);
          window.removeEventListener('resize', this.resize);
          if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
          if (this.observer) this.observer.disconnect();
        }

        toggle() {
          const shouldRun = this.visible && !document.hidden;
          if (shouldRun && !this.running) {
            this.running = true;
            this.last = performance.now();
            this.frame = requestAnimationFrame(this.tick);
          } else if (!shouldRun) {
            this.running = false;
            cancelAnimationFrame(this.frame);
          }
        }

        resize() {
          const rect = this.getBoundingClientRect();
          const dpr = Math.min(window.devicePixelRatio || 1, 2);
          this.w = rect.width;
          this.h = rect.height;
          this.canvas.width = Math.round(this.w * dpr);
          this.canvas.height = Math.round(this.h * dpr);
          this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
          const target = Math.max(4, Math.round((Number(this.dataset.count) || 30) * Math.min(1, this.w / 1440 + 0.25)));
          this.petals = this.petals || [];
          while (this.petals.length < target) this.petals.push(this.makePetal(true));
          this.petals.length = target;
        }

        makePetal(anywhere) {
          const s = this.size * (0.6 + Math.random() * 0.8);
          return {
            x: Math.random() * this.w,
            y: anywhere ? Math.random() * this.h : -s * 2,
            s,
            vy: (0.25 + Math.random() * 0.5) * this.speed * 0.35,
            sway: 0.6 + Math.random() * 1.4,
            phase: Math.random() * Math.PI * 2,
            rot: Math.random() * Math.PI * 2,
            vr: (Math.random() - 0.5) * 0.04,
            flip: Math.random() * Math.PI * 2,
            vf: 0.02 + Math.random() * 0.04,
            color: this.colors[Math.floor(Math.random() * this.colors.length)],
            shape: this.shapes[Math.floor(Math.random() * this.shapes.length)],
          };
        }

        drawPetal(p) {
          const ctx = this.ctx;
          const s = p.s;
          const squash = Math.abs(Math.cos(p.flip)) * 0.7 + 0.3;
          ctx.save();
          ctx.translate(p.x, p.y);
          ctx.rotate(p.rot);
          ctx.globalAlpha = this.alpha;
          ctx.fillStyle = p.color;
          ctx.beginPath();
          switch (p.shape) {
            case 'confetti':
              ctx.scale(1, squash);
              ctx.fillRect(-s * 0.22, -s * 0.45, s * 0.44, s * 0.9);
              break;
            case 'coin':
              ctx.scale(squash, 1);
              ctx.arc(0, 0, s * 0.5, 0, Math.PI * 2);
              ctx.fill();
              ctx.globalAlpha = this.alpha * 0.45;
              ctx.strokeStyle = '#ffffff';
              ctx.lineWidth = Math.max(1, s * 0.08);
              ctx.beginPath();
              ctx.arc(0, 0, s * 0.32, 0, Math.PI * 2);
              ctx.stroke();
              break;
            case 'sparkle':
              ctx.scale(squash * 0.4 + 0.6, 1);
              ctx.moveTo(0, -s * 0.6);
              ctx.quadraticCurveTo(s * 0.08, -s * 0.08, s * 0.6, 0);
              ctx.quadraticCurveTo(s * 0.08, s * 0.08, 0, s * 0.6);
              ctx.quadraticCurveTo(-s * 0.08, s * 0.08, -s * 0.6, 0);
              ctx.quadraticCurveTo(-s * 0.08, -s * 0.08, 0, -s * 0.6);
              ctx.fill();
              break;
            case 'percent':
              ctx.scale(squash * 0.5 + 0.5, 1);
              ctx.font = '700 ' + Math.round(s * 1.25) + 'px ' + this.font;
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              ctx.fillText('%', 0, 0);
              break;
            case 'tag': {
              ctx.scale(squash * 0.5 + 0.5, 1);
              const w = s * 1.1;
              const h = s * 0.6;
              ctx.moveTo(-w / 2, 0);
              ctx.lineTo(-w / 2 + h / 2, -h / 2);
              ctx.lineTo(w / 2, -h / 2);
              ctx.lineTo(w / 2, h / 2);
              ctx.lineTo(-w / 2 + h / 2, h / 2);
              ctx.closePath();
              ctx.fill();
              ctx.globalCompositeOperation = 'destination-out';
              ctx.beginPath();
              ctx.arc(-w / 2 + h * 0.5, 0, h * 0.14, 0, Math.PI * 2);
              ctx.fill();
              break;
            }
            default:
              ctx.scale(1, squash);
              ctx.moveTo(0, -s / 2);
              ctx.bezierCurveTo(s * 0.55, -s * 0.45, s * 0.5, s * 0.3, 0, s / 2);
              ctx.bezierCurveTo(-s * 0.5, s * 0.3, -s * 0.55, -s * 0.45, 0, -s / 2);
              ctx.fill();
              ctx.globalAlpha = this.alpha * 0.35;
              ctx.fillStyle = '#ffffff';
              ctx.beginPath();
              ctx.ellipse(-s * 0.12, -s * 0.08, s * 0.1, s * 0.28, 0.3, 0, Math.PI * 2);
              ctx.fill();
          }
          ctx.restore();
        }

        tick(now) {
          if (!this.running) return;
          const dt = Math.min(3, (now - this.last) / 16.67);
          this.last = now;
          this.ctx.clearRect(0, 0, this.w, this.h);
          for (let i = 0; i < this.petals.length; i++) {
            const p = this.petals[i];
            p.phase += 0.015 * dt;
            p.y += p.vy * dt;
            p.x += Math.sin(p.phase) * p.sway * 0.5 * dt + 0.15 * dt;
            p.rot += p.vr * dt;
            p.flip += p.vf * dt;
            if (p.y > this.h + p.s * 2 || p.x > this.w + p.s * 2) {
              this.petals[i] = this.makePetal(false);
              this.petals[i].x = Math.random() * this.w * 1.1 - this.w * 0.1;
            }
            this.drawPetal(p);
          }
          this.frame = requestAnimationFrame(this.tick);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["slider-w"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('slider-w')) {
    customElements.define(
      'slider-w',
      class SliderW extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('ul');
          this.querySelectorAll('[data-dir]').forEach((btn) =>
            btn.addEventListener('click', () => {
              const slide = this.track.firstElementChild;
              if (!slide) return;
              const step = slide.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0);
              const max = this.track.scrollWidth - this.track.clientWidth - 2;
              const dir = Number(btn.dataset.dir);
              if (dir > 0 && this.track.scrollLeft >= max) this.track.scrollTo({ left: 0 });
              else if (dir < 0 && this.track.scrollLeft <= 0) this.track.scrollTo({ left: max });
              else this.track.scrollBy({ left: dir * step });
            })
          );
          document.addEventListener('shopify:block:select', (e) => {
            const el = this.track.querySelector(`[data-shopify-editor-block*="${e.detail.blockId}"]`);
            if (el) this.track.scrollTo({ left: el.offsetLeft - this.track.offsetLeft });
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
